module.exports = {
  canvasStyle: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    height: 0,
    overflow: 'hidden',
    'padding-top': 0,
    'padding-bottom': 0,
    border: 'none'
  },
  mirrorProps: [
    'box-sizing',
    'width',
    'font-size',
    'font-weight',
    'font-family',
    'font-style',
    'letter-spacing',
    'text-indent',
    'white-space',
    'word-break',
    'padding-left',
    'padding-right'
  ]
}



//////////////////
// WEBPACK FOOTER
// ./~/react-lines-ellipsis/lib/common.js
// module id = 1796
// module chunks = 1